import api from './client';

export const getSld = (projectId) => api.get('/sld', { params: { project: projectId } });
